import { render, staticRenderFns } from "./Contrats.vue?vue&type=template&id=1196b8e5&"
import script from "./Contrats.vue?vue&type=script&lang=js&"
export * from "./Contrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports